import { render, staticRenderFns } from "./ContactSheet.vue?vue&type=template&id=2c63e29a&scoped=true&"
import script from "./ContactSheet.vue?vue&type=script&lang=js&"
export * from "./ContactSheet.vue?vue&type=script&lang=js&"
import style0 from "./ContactSheet.vue?vue&type=style&index=0&id=2c63e29a&scoped=true&lang=scss&"
import style1 from "./ContactSheet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63e29a",
  null
  
)

export default component.exports